import { useState } from "react";

import { Popover, PopoverContent, PopoverTrigger } from "@/app/components/ui/popover";
import { convertArrayToUl, type ListItem } from "@/app/handlers/utilityFunctions";

export interface TipsContent {
	label?: string;
	content: ListItem[];
}

interface TipsProps {
	content: TipsContent;
}

/**
 * "Tips" helper popover. Opens on hover and on click; the trigger is a real
 * button, so it also opens with the keyboard (Enter/Space) and closes on Escape.
 */
function Tips({ content }: TipsProps) {
	const [open, setOpen] = useState(false);

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<button
					type="button"
					className="cursor-pointer border-[#7a7a7a] border-b border-dashed font-medium text-xs text-primary-700"
					onMouseEnter={() => setOpen(true)}
					onMouseLeave={() => setOpen(false)}
				>
					Tips
				</button>
			</PopoverTrigger>
			<PopoverContent
				side="top"
				align="start"
				className="w-[323px] max-w-[90vw] px-3 py-2"
				onMouseEnter={() => setOpen(true)}
				onMouseLeave={() => setOpen(false)}
			>
				{content.label && <p className="font-bold">{content.label}</p>}
				<div
					dangerouslySetInnerHTML={{
						__html: convertArrayToUl(content.content),
					}}
				/>
			</PopoverContent>
		</Popover>
	);
}

export default Tips;
